const getStagePositionKey = (slug) => `board.stagePosition.${slug}`;
const getZoomKey = (slug) => `board.zoom.${slug}`;
export function loadStagePosition(slug) {
    try {
        const raw = localStorage.getItem(getStagePositionKey(slug));
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed.x === 'number' && typeof parsed.y === 'number') {
            return { x: parsed.x, y: parsed.y };
        }
    }
    catch (_a) {
        // ignore
    }
    return null;
}
export function saveStagePosition(slug, position) {
    try {
        localStorage.setItem(getStagePositionKey(slug), JSON.stringify(position));
    }
    catch (_a) {
        // ignore
    }
}
export function loadZoom(slug) {
    try {
        const raw = localStorage.getItem(getZoomKey(slug));
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        if (typeof parsed === 'number' && !Number.isNaN(parsed)) {
            return parsed;
        }
    }
    catch (_a) {
        // ignore
    }
    return null;
}
export function saveZoom(slug, zoom) {
    try {
        localStorage.setItem(getZoomKey(slug), JSON.stringify(zoom));
    }
    catch (_a) {
        // ignore
    }
}
const getBoardSettingsKey = (slug) => `board.settings.${slug}`;
/**
 * Загружает настройки панели инструментов доски из localStorage.
 * @param slug - Идентификатор доски.
 * @returns Настройки или null, если не найдены.
 */
export function loadBoardSettings(slug) {
    try {
        const raw = localStorage.getItem(getBoardSettingsKey(slug));
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') {
            return {
                showGrid: typeof parsed.showGrid === 'boolean' ? parsed.showGrid : undefined,
                snapToGrid: typeof parsed.snapToGrid === 'boolean' ? parsed.snapToGrid : undefined,
                inputMode: parsed.inputMode === 'trackpad' || parsed.inputMode === 'mouse'
                    ? parsed.inputMode
                    : undefined,
            };
        }
    }
    catch (_a) {
        // ignore
    }
    return null;
}
/**
 * Сохраняет настройки панели инструментов доски в localStorage.
 * @param slug - Идентификатор доски.
 * @param settings - Настройки для сохранения.
 */
export function saveBoardSettings(slug, settings) {
    try {
        localStorage.setItem(getBoardSettingsKey(slug), JSON.stringify(settings));
    }
    catch (_a) {
        // ignore
    }
}
